module.exports = __webpack_public_path__ + "assets/img/hzhb5.712a62b2.png";